export const navigationItemsFI = [
  { path: '/dashboard', type: 'home', titleKey: 'navigation.dashboard' },
  { path: '/credit-information', type: 'credit', titleKey: 'navigation.creditInformation' },
  { path: '/other-services', type: 'other', titleKey: 'navigation.otherServices' },
  { path: '/profile', type: 'profile', titleKey: 'navigation.profile' },
  { path: '/invoices', type: 'invoices', titleKey: 'navigation.invoices' },
  { path: '/transactions', type: 'transactions', titleKey: 'navigation.transactions' },
];

export const navigationItemsAUIL = [
  { path: '/dashboard', type: 'home', titleKey: 'navigation.dashboard' },
  { path: '/credit-information', type: 'credit', titleKey: 'navigation.creditInformation' },
  { path: '/repayment-info', type: 'invoices', titleKey: 'navigation.repaymentInfo' },
  { path: '/transactions', type: 'transactions', titleKey: 'navigation.transactions' },
];

export const navigationItemsAU = [
  ...navigationItemsAUIL,
  { path: '/statement-of-account', type: 'statements', titleKey: 'navigation.statementOfAccount' },
];

export const navigationItemsCZ = [
  { path: '/dashboard', type: 'home', titleKey: 'navigation.dashboard' },
  { path: '/credit-information', type: 'credit', titleKey: 'navigation.creditInformation' },
  { path: '/profile', type: 'profile', titleKey: 'navigation.profile' },
  { path: '/invoices', type: 'invoices', titleKey: 'navigation.invoices' },
  { path: '/transactions', type: 'transactions', titleKey: 'navigation.transactions' },
  { path: '/other-services', type: 'other', titleKey: 'navigation.otherServices' },
];
